/* ============================================================
   AEOC QUIZ WIDGET — Shopify theme asset
   Reads config from window.AEOC_QUIZ_CONFIG (set in snippet).
   ============================================================ */
(function () {
  'use strict';

  /* ============================================================
     CONFIG (merge Liquid-provided values with defaults)
     ============================================================ */
  const INJECTED = (typeof window !== 'undefined' && window.AEOC_QUIZ_CONFIG) || {};
  const CONFIG = {
    klaviyoPublicSiteId: INJECTED.klaviyoPublicSiteId || 'PLACEHOLDER',
    shopifyDomain: INJECTED.shopifyDomain || 'https://www.australianeucalyptusoil.com.au',
    isPdp: !!INJECTED.isPdp,
    quizListId: INJECTED.quizListId || '',
    quizLogUrl: INJECTED.quizLogUrl || '',
    conciergeOptinUrl: INJECTED.conciergeOptinUrl || '',
    isReturning: !!INJECTED.isReturning,
    discountCode: 'QUIZ15',
    discountPercent: 15,
    discountEmail: 'QUIZ15',
    discountEmailPercent: 15,
    discountSms: 'QUIZ15',
    discountSmsPercent: 15,
    // EOFY SALE MODE — while true, the on-site quiz drops the QUIZ15/MOULDKIT25 codes (so nothing
    // stacks on the already-discounted sale prices) and shows the sale price + sale copy instead.
    // The Klaviyo flow emails are untouched (codes still in them) so post-sale buyers keep their reward.
    // Set saleMode back to false when the EOFY sale ends to restore codes + normal copy.
    saleMode: false, // DRAFT preview = post-sale ("Get 15% off"). IMPORTANT: set TRUE again before pushing to LIVE while the EOFY sale is still running.
    salePercent: 20,
    cookies: {
      quizTaken: 'aeoc_quiz_taken',
      welcomeDismissed: 'aeoc_welcome_modal_dismissed',
      welcomeShown: 'aeoc_welcome_shown',
      exitIntentShown: 'aeoc_exit_intent_shown',
      pdpSlideupShown: 'aeoc_pdp_slideup_shown'
    },
    delays: {
      welcomeModalSeconds: 8,
      pdpSlideupDwellSeconds: 15,
      pdpSlideupScrollPercent: 50,
      calculatingSeconds: 3
    },
    copy: {
      welcomePopup: {
        headline: "Get 15% off your first order",
        headlineReturning: "Welcome back",
        headlineSale: "Everything's 20% off right now",
        prompt: "Pick what's bugging you:",
        micro: "30 seconds to your match",
        dismiss: "No thanks, I'll keep guessing",
        trust: { rating: "4.9", reviews: "5,000+ reviews", seenLabel: "As seen on", logoUrl: "https://cdn.shopify.com/s/files/1/0734/6146/5401/files/7_Sunrise_Logo_2021.webp?v=1785365861", logoAlt: "As seen on Sunrise" }
      },
      pdpSlideup: '30 seconds to be sure →',
      headerLink: "Quiz - Get 15% Off",
      emailGate: {
        headline: 'Your match is ready.',
        subline: 'One tap away — plus 15% off your first order.',
        emailPlaceholder: 'your@email.com',
        cta: 'Show my match →',
        skip: 'Just show me my match',
        micro: "Your match + code also land in your inbox — unsubscribe any time."
      },
      calculating: [
        'Reading your answers…',
        'Cross-checking with our products…',
        'Found it. Loading your match…'
      ]
    }
  };

  /* ============================================================
     QUESTION DATA — all 6 branches' routing tree
     ============================================================ */
  const Q1 = {
    headline: 'Something here will sound familiar.',
    question: 'Where do you want to start?',
    answers: [
      { text: 'Mould that keeps coming back', next: 'q2_mould' },
      { text: "What's actually in my laundry detergent", next: 'q2_laundry' },
      { text: 'That dishwasher smell', next: 'q2_dishwasher' },
      { text: 'What I spray on the kitchen bench', next: 'q2_kitchen' },
      { text: 'The fumes when I clean the shower', next: 'q2_shower' },
      { text: 'Streaky glass & stainless', next: 'q2_glass_ss' }
    ]
  };

  const BRANCHES = {
    q2_mould: {
      headline: 'Got it —',
      question: 'Tell us a bit more.',
      answers: [
        { text: 'Black spots in the shower — grout, tiles, silicone', set: { branch: 'mould', product_path: 'mould_solution_kit' }, next: 'q3_mould' },
        { text: 'Dark patches on painted walls or ceilings', set: { branch: 'wall', product_path: 'wall_cleaner' }, next: 'q3_mould' },
        { text: 'Both — bathroom and walls', set: { branch: 'mould', product_path: 'complete_mould_kit' }, next: 'q3_mould' },
        { text: "Honestly I haven't checked everywhere — it keeps coming back in the shower", set: { branch: 'mould', product_path: 'complete_mould_kit' }, next: 'q3_mould' }
      ]
    },
    q3_mould: {
      headline: "What's made you start looking for something different?",
      question: 'Pick the one that sounds like you.',
      answers: [
        { text: "Bleach isn't working — the mould keeps coming back no matter what I use", set: { version: 'A' }, next: 'email' },
        { text: "I hate the smell of bleach and I'm not convinced it's actually solving the problem", set: { version: 'B' }, next: 'email' },
        { text: "I've been trying to move away from harsh chemicals at home", set: { version: 'C' }, next: 'email' },
        { text: 'I manage a rental or Airbnb and need something that works properly between tenants', set: { version: 'D' }, next: 'email' }
      ]
    },
    q2_laundry: {
      headline: "Got it — the laundry.",
      question: "Which sounds most like you?",
      answers: [
        { text: "No idea what's actually in mine", set: { version: 'A' }, next: 'q3_laundry' },
        { text: "Someone's skin gets itchy", set: { version: 'B' }, next: 'q3_laundry' },
        { text: "Clothes smell of detergent, not clean", set: { version: 'C' }, next: 'q3_laundry' },
        { text: "It's the last thing I haven't switched", set: { version: 'D' }, next: 'q3_laundry' }
      ]
    },
    q3_laundry: {
      headline: 'Powder or liquid?',
      question: 'Which do you usually reach for?',
      answers: [
        { text: "I've always used powder. Never had a problem with it.", set: { branch: 'laundry_powder' }, next: 'q4_laundry_scent' },
        { text: 'I prefer liquid — I just do.', set: { branch: 'laundry_liquid', scent: 'eucalyptus' }, next: 'email' }
      ]
    },
    q4_laundry_scent: {
      headline: 'Last one',
      question: 'Which scent is yours?',
      answers: [
        { text: 'Eucalyptus', set: { scent: 'eucalyptus' }, next: 'email' },
        { text: 'Lemon Myrtle', set: { scent: 'lemon_myrtle' }, next: 'email' },
        { text: 'Lavender', set: { scent: 'lavender' }, next: 'email' },
        { text: 'Peppermint', set: { scent: 'peppermint' }, next: 'email' },
        { text: "I'm not sure — show me your most popular", set: { scent: 'eucalyptus' }, next: 'email' }
      ]
    },
    q2_dishwasher: {
      headline: "Got it — the dishwasher.",
      question: "What's the main thing for you?",
      answers: [
        { text: "Cloudy glasses, even with rinse aid", set: { branch: 'dishwasher', version: 'A' }, next: 'q3_dishwasher_scent' },
        { text: "What those chemicals might leave behind", set: { branch: 'dishwasher', version: 'B' }, next: 'q3_dishwasher_scent' },
        { text: "Natural powders have let me down before", set: { branch: 'dishwasher', version: 'C' }, next: 'q3_dishwasher_scent' },
        { text: "My kids eat off these plates", set: { branch: 'dishwasher', version: 'D' }, next: 'q3_dishwasher_scent' }
      ]
    },
    q3_dishwasher_scent: {
      headline: 'Last one',
      question: 'Which scent is yours?',
      answers: [
        { text: 'Eucalyptus', set: { scent: 'eucalyptus' }, next: 'email' },
        { text: 'Lemon Myrtle', set: { scent: 'lemon_myrtle' }, next: 'email' },
        { text: 'Peppermint', set: { scent: 'peppermint' }, next: 'email' },
        { text: 'Not sure — show me your most popular', set: { scent: 'eucalyptus' }, next: 'email' }
      ]
    },
    q2_kitchen: {
      headline: "Got it — the kitchen.",
      question: "Where does it matter most?",
      answers: [
        { text: "The bench where I prep food", set: { branch: 'bench_spray' }, next: 'q3_bench_scent' },
        { text: "The dishes we wash by hand", set: { branch: 'dishwash_liquid' }, next: 'q3_dishwash_scent' },
        { text: "The soap on everyone's hands", set: { branch: 'hand_wash' }, next: 'q3_handwash_scent' }
      ]
    },
    q3_bench_scent: {
      headline: 'Last one',
      question: 'Which scent is yours?',
      answers: [
        { text: 'Eucalyptus', set: { scent: 'eucalyptus' }, next: 'email' },
        { text: 'Lemon Myrtle', set: { scent: 'lemon_myrtle' }, next: 'email' },
        { text: 'Lavender', set: { scent: 'lavender' }, next: 'email' },
        { text: 'Peppermint', set: { scent: 'peppermint' }, next: 'email' },
        { text: 'Citrus Burst', set: { scent: 'citrus_burst' }, next: 'email' },
        { text: 'Not sure — show me your most popular', set: { scent: 'eucalyptus' }, next: 'email' }
      ]
    },
    q3_dishwash_scent: {
      headline: 'Last one',
      question: 'Scented or fragrance-free?',
      answers: [
        { text: 'Eucalyptus', set: { scent: 'eucalyptus' }, next: 'email' },
        { text: 'No scent', set: { scent: 'unscented' }, next: 'email' }
      ]
    },
    q3_handwash_scent: {
      headline: 'Last one',
      question: 'Which scent is yours?',
      answers: [
        { text: 'Bergamot, Geranium & Rose', set: { scent: 'bergamot' }, next: 'email' },
        { text: 'Eucalyptus & Lemon Scented Tea Tree', set: { scent: 'eucalyptus' }, next: 'email' },
        { text: 'Grapefruit, Orange & Lime', set: { scent: 'grapefruit' }, next: 'email' },
        { text: 'Sensitive Skin (Unscented)', set: { scent: 'sensitive' }, next: 'email' }
      ]
    },
    q2_shower: {
      headline: "Got it — the shower.",
      question: "What bothers you most?",
      answers: [
        { text: "What I'm breathing while I clean", set: { branch: 'shower', version: 'A' }, next: 'email' },
        { text: "The chemical smell hangs around for hours", set: { branch: 'shower', version: 'B' }, next: 'email' },
        { text: "My kids use that shower", set: { branch: 'shower', version: 'C' }, next: 'email' },
        { text: "It's the last thing I haven't switched", set: { branch: 'shower', version: 'D' }, next: 'email' }
      ]
    },
    q2_glass_ss: {
      headline: "Got it — the shine.",
      question: "Which surfaces?",
      answers: [
        { text: "Mirrors, windows, shower screen", set: { branch: 'glass_stainless', surface: 'glass' }, next: 'email' },
        { text: "Fridge, rangehood, sink", set: { branch: 'glass_stainless', surface: 'stainless_steel' }, next: 'email' },
        { text: "Both — nothing shines like it should", set: { branch: 'glass_stainless', surface: 'both' }, next: 'email' }
      ]
    }
  };

  /* ============================================================
     PRODUCTS — matched outcome → display data + cart links
     ============================================================ */
  const PRODUCTS = {
    mould_solution_kit: {
      name: 'Clove & Eucalyptus Mould Spray',
      size: '500ml — Australian made',
      rrp: 20.50, price: 17.43, save: 3.07,
      img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/114.jpg?v=1723643253',
      variant: '49750937502009',
      kit: { label: 'THE FULL MOULD RESET — 25% OFF', headline: 'Sort the mould. Stock the laundry.', desc: 'Mould Spray for tile, grout and silicone. Wall Cleaner for painted walls and ceilings. Plus Eucalyptus Laundry Powder — 1.5 kg, about 125 washes of the same clean.', products: 'Mould Spray 500ml + Wall Cleaner 500ml + Eucalyptus Laundry Powder 1.5kg', rrp: 67.50, price: 50.63, save: 16.87, variants: '49750937502009:1,49751074996537:1,52229701763385:1', discountCode: 'MOULDKIT25', saveText: 'Save $16.87 — 25% off the bundle' }
    },
    wall_cleaner: {
      name: 'All Natural Mould Remover Wall Cleaner',
      size: '500ml — Australian made',
      rrp: 16.00, price: 13.60, save: 2.40,
      img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/724.png?v=1723645084',
      variant: '49751074996537',
      kit: { label: 'THE FULL MOULD RESET — 25% OFF', headline: 'Sort the walls. Stock the laundry.', desc: 'Wall Cleaner for painted walls and ceilings. Mould Spray for tile, grout and silicone. Plus Eucalyptus Laundry Powder — 1.5 kg, about 125 washes of the same clean.', products: 'Wall Cleaner 500ml + Mould Spray 500ml + Eucalyptus Laundry Powder 1.5kg', rrp: 67.50, price: 50.63, save: 16.87, variants: '49751074996537:1,49750937502009:1,52229701763385:1', discountCode: 'MOULDKIT25', saveText: 'Save $16.87 — 25% off the bundle' }
    },
    complete_mould_kit: {
      name: 'The Mould + Wall Kit',
      size: 'Mould Spray + Wall Cleaner — both 500ml',
      rrp: 36.50, price: 31.03, save: 5.47,
      img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/114.jpg?v=1723643253',
      variant: '49750937502009',
      cart_variants: '49750937502009:1,49751074996537:1',
      kit: { label: 'THE FULL MOULD RESET — 25% OFF', headline: 'Add the laundry powder, unlock 25% off the lot.', desc: 'Your kit, plus Eucalyptus Laundry Powder — 1.5 kg, about 125 washes of the same clean for everything you wear.', products: 'Mould Spray 500ml + Wall Cleaner 500ml + Eucalyptus Laundry Powder 1.5kg', rrp: 67.50, price: 50.63, save: 16.87, variants: '49750937502009:1,49751074996537:1,52229701763385:1', discountCode: 'MOULDKIT25', saveText: 'Save $16.87 — 25% off the bundle' }
    },
    laundry_powder_eucalyptus: { name: 'Eucalyptus Laundry Powder', size: '1.5 kg — Australian made', rrp: 31.00, price: 26.35, save: 4.65, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/The_Australian_Eucalyptus_Oil_Company_-_The_Australian_Eucalyptus_Oil_Company_Eucalyptus_Laundry_Powder_-_Best_Laundry_Product-2_9af766bd-b4dd-4c02-8427-25262561302d.jpg?v=1776344351', variant: '52229701763385', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your dishwasher', desc: 'Same Eucalyptus. Same plant + mineral blend. Same 100% money-back guarantee.', products: 'Eucalyptus Laundry Powder 1.5kg + Eucalyptus Dishwasher Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52229701763385:1,52283942469945:1' } },
    laundry_powder_lavender: { name: 'Lavender Laundry Powder', size: '1.5 kg — Australian made', rrp: 31.00, price: 26.35, save: 4.65, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/116_4fbbc10a-dbea-43b8-a560-26b844f5c89e.jpg?v=1776344350', variant: '52229701927225', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your dishwasher', desc: 'Top-selling Eucalyptus Dishwasher Powder. Same plant + mineral blend, same 100% money-back guarantee.', products: 'Lavender Laundry Powder 1.5kg + Eucalyptus Dishwasher Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52229701927225:1,52283942469945:1' } },
    laundry_powder_peppermint: { name: 'Peppermint Laundry Powder', size: '1.5 kg — Australian made', rrp: 31.00, price: 26.35, save: 4.65, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/242_b30c4c84-de6f-4a8d-8ef4-02999266caef.jpg?v=1776344351', variant: '52229702091065', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your dishwasher', desc: 'Same Peppermint. Same plant + mineral blend. Same 100% money-back guarantee.', products: 'Peppermint Laundry Powder 1.5kg + Peppermint Dishwasher Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52229702091065:1,52283942797625:1' } },
    laundry_powder_lemon_myrtle: { name: 'Lemon Myrtle Laundry Powder', size: '1.5 kg — Australian made', rrp: 31.00, price: 26.35, save: 4.65, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/LMLP1_a7fbb246-977a-4ed5-9f8a-0f56ffc040a7.jpg?v=1776344350', variant: '52229702254905', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your dishwasher', desc: 'Same Lemon Myrtle. Same plant + mineral blend. Same 100% money-back guarantee.', products: 'Lemon Myrtle Laundry Powder 1.5kg + Lemon Myrtle Dishwasher Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52229702254905:1,52283942633785:1' } },
    laundry_liquid_eucalyptus: { name: 'Eucalyptus Laundry Liquid', size: '1 Litre — Australian made', rrp: 20.00, price: 17.00, save: 3.00, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/LL1.jpg?v=1723643395', variant: '49750943334713', kit: { label: 'LAUNDRY LIQUID + LAUNDRY POWDER COMBO', headline: 'Stock the laundry naturally', desc: 'Same eucalyptus. Same plant-based blend. Same 100% money-back guarantee.', products: 'Laundry Liquid 1L + Eucalyptus Laundry Powder 1.5kg', rrp: 51.00, price: 43.35, save: 7.65, variants: '49750943334713:1,52229701763385:1' } },
    dishwasher_eucalyptus: { name: 'Eucalyptus Dishwasher Powder', size: '1.5 kg — Australian made', rrp: 32.00, price: 27.20, save: 4.80, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/DW1_852efcae-5313-4954-867d-34f3f1041f8c.jpg?v=1776403802', variant: '52283942469945', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your laundry', desc: 'Same Eucalyptus. Same plant + mineral blend. Same 100% money-back guarantee.', products: 'Eucalyptus Dishwasher Powder 1.5kg + Eucalyptus Laundry Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52283942469945:1,52229701763385:1' } },
    dishwasher_lemon_myrtle: { name: 'Lemon Myrtle Dishwasher Powder', size: '1.5 kg — Australian made', rrp: 32.00, price: 27.20, save: 4.80, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/169_ce7e67cb-6d9d-4901-b535-023f19f0d12d.jpg?v=1776403801', variant: '52283942633785', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your laundry', desc: 'Same Lemon Myrtle. Same plant + mineral blend. Same 100% money-back guarantee.', products: 'Lemon Myrtle Dishwasher Powder 1.5kg + Lemon Myrtle Laundry Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52283942633785:1,52229702254905:1' } },
    dishwasher_peppermint: { name: 'Peppermint Dishwasher Powder', size: '1.5 kg — Australian made', rrp: 32.00, price: 27.20, save: 4.80, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/PMintDW1_ffcbba29-8a28-40ba-a761-2b58a19eea7f.jpg?v=1776403802', variant: '52283942797625', kit: { label: 'DISHWASHER + LAUNDRY POWDER COMBO', headline: 'Pair it with your laundry', desc: 'Same Peppermint. Same plant + mineral blend. Same 100% money-back guarantee.', products: 'Peppermint Dishwasher Powder 1.5kg + Peppermint Laundry Powder 1.5kg', rrp: 63.00, price: 53.55, save: 9.45, variants: '52283942797625:1,52229702091065:1' } },
    bench_spray_eucalyptus: { name: 'Eucalyptus Bench Spray', size: '500 ml — Australian made', rrp: 15.00, price: 12.75, save: 2.25, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/The_Australian_Eucalyptus_Oil_Company_-_Australian_Eucalyptus_Bench_Spray_-_Best_Natural_Cleaning_Product_2_a3c9fd8b-499a-4609-8bfe-dd57ac3ad099.jpg?v=1776254818', variant: '52146498240825', kit: { label: 'BENCH SPRAY + DISHWASH LIQUID COMBO', headline: 'Pair it with the sink', desc: 'Plant-based duo for the kitchen.', products: 'Eucalyptus Bench Spray + Eucalyptus Dishwash Liquid', rrp: 30.00, price: 25.50, save: 4.50, variants: '52146498240825:1,52600870175033:1' } },
    bench_spray_lavender: { name: 'Lavender Bench Spray', size: '500 ml — Australian made', rrp: 15.00, price: 12.75, save: 2.25, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/LAVSC500_60a593e7-2f5f-4950-97ba-42f187912ebf.jpg?v=1776254818', variant: '52146498339129', kit: { label: 'BENCH SPRAY + DISHWASH LIQUID COMBO', headline: 'Pair it with the sink', desc: 'Plant-based duo for the kitchen.', products: 'Lavender Bench Spray + Eucalyptus Dishwash Liquid', rrp: 30.00, price: 25.50, save: 4.50, variants: '52146498339129:1,52600870175033:1' } },
    bench_spray_peppermint: { name: 'Peppermint Bench Spray', size: '500 ml — Australian made', rrp: 15.00, price: 12.75, save: 2.25, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/PSC500_ac03b9b9-0927-440e-937a-ee1983e4378e.jpg?v=1776254817', variant: '52146498437433', kit: { label: 'BENCH SPRAY + DISHWASH LIQUID COMBO', headline: 'Pair it with the sink', desc: 'Plant-based duo for the kitchen.', products: 'Peppermint Bench Spray + Eucalyptus Dishwash Liquid', rrp: 30.00, price: 25.50, save: 4.50, variants: '52146498437433:1,52600870175033:1' } },
    bench_spray_lemon_myrtle: { name: 'Lemon Myrtle Bench Spray', size: '500 ml — Australian made', rrp: 15.00, price: 12.75, save: 2.25, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/LMSC500_7fad47a3-9474-41f0-973c-710580c57058.jpg?v=1776254818', variant: '52146498535737', kit: { label: 'BENCH SPRAY + DISHWASH LIQUID COMBO', headline: 'Pair it with the sink', desc: 'Plant-based duo for the kitchen.', products: 'Lemon Myrtle Bench Spray + Eucalyptus Dishwash Liquid', rrp: 30.00, price: 25.50, save: 4.50, variants: '52146498535737:1,52600870175033:1' } },
    bench_spray_citrus_burst: { name: 'Citrus Burst Bench Spray', size: '500 ml — Australian made', rrp: 15.00, price: 12.75, save: 2.25, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/480_6c68ac9c-406d-4e36-b2db-6469baa5e17a.jpg?v=1776254818', variant: '52146498634041', kit: { label: 'BENCH SPRAY + DISHWASH LIQUID COMBO', headline: 'Pair it with the sink', desc: 'Plant-based duo for the kitchen.', products: 'Citrus Burst Bench Spray + Eucalyptus Dishwash Liquid', rrp: 30.00, price: 25.50, save: 4.50, variants: '52146498634041:1,52600870175033:1' } },
    dishwash_liquid_eucalyptus: { name: 'Eucalyptus Dishwash Liquid', size: '500 ml — Australian made', rrp: 15.00, price: 12.75, save: 2.25, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/270_9aeb1501-ee42-4111-9738-ddbde580c75d.jpg?v=1776923209', variant: '52600870175033', kit: { label: 'DISHWASH LIQUID + BENCH SPRAY COMBO', headline: 'Pair it with the bench', desc: 'Plant-based duo for the kitchen.', products: 'Eucalyptus Dishwash Liquid + Eucalyptus Bench Spray', rrp: 30.00, price: 25.50, save: 4.50, variants: '52600870175033:1,52146498240825:1' } },
    dishwash_liquid_unscented: { name: 'Unscented Dishwash Liquid', size: '500 ml — Australian made', rrp: 14.00, price: 11.90, save: 2.10, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/271.jpg?v=1723643825', variant: '52600870240569', kit: { label: 'DISHWASH LIQUID + BENCH SPRAY COMBO', headline: 'Pair it with the bench', desc: 'Plant-based duo for the kitchen.', products: 'Unscented Dishwash Liquid + Eucalyptus Bench Spray', rrp: 29.00, price: 24.65, save: 4.35, variants: '52600870240569:1,52146498240825:1' } },
    hand_wash_bergamot: { name: 'Bergamot, Geranium & Rose Pure Castile Hand Wash', size: '500 ml — Australian made', rrp: 20.00, price: 17.00, save: 3.00, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/485_5ea198bc-68bd-456a-98c9-6aae28a15f40.jpg?v=1776724638', variant: '52445516890425', kit: { label: 'HAND WASH + BENCH SPRAY COMBO', headline: 'Pair it with the bench', desc: 'Plant-based duo for the kitchen.', products: 'Bergamot Hand Wash + Lavender Bench Spray', rrp: 35.00, price: 29.75, save: 5.25, variants: '52445516890425:1,52146498339129:1' } },
    hand_wash_grapefruit: { name: 'Grapefruit, Orange & Lime Pure Castile Hand Wash', size: '500 ml — Australian made', rrp: 20.00, price: 17.00, save: 3.00, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/486_6621aa0a-da69-4462-abc2-cf7cca57afea.jpg?v=1776724638', variant: '52445516955961', kit: { label: 'HAND WASH + BENCH SPRAY COMBO', headline: 'Pair it with the bench', desc: 'Plant-based duo for the kitchen.', products: 'Grapefruit Hand Wash + Citrus Burst Bench Spray', rrp: 35.00, price: 29.75, save: 5.25, variants: '52445516955961:1,52146498634041:1' } },
    hand_wash_eucalyptus: { name: 'Eucalyptus & Lemon Tea Tree Pure Castile Hand Wash', size: '500 ml — Australian made', rrp: 20.00, price: 17.00, save: 3.00, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/487_200024f9-4316-4c00-b446-473b10a17d89.jpg?v=1776724639', variant: '52445517021497', kit: { label: 'HAND WASH + BENCH SPRAY COMBO', headline: 'Pair it with the bench', desc: 'Plant-based duo for the kitchen.', products: 'Eucalyptus Hand Wash + Eucalyptus Bench Spray', rrp: 35.00, price: 29.75, save: 5.25, variants: '52445517021497:1,52146498240825:1' } },
    hand_wash_sensitive: { name: 'Sensitive (Unscented) Pure Castile Hand Wash', size: '500 ml — Australian made', rrp: 19.00, price: 16.15, save: 2.85, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/Soap_6377347b-0e28-4845-be84-30e4d44ef793.jpg?v=1776724641', variant: '52445517087033', kit: { label: 'HAND WASH + BENCH SPRAY COMBO', headline: 'Pair it with the bench', desc: 'Plant-based duo for the kitchen.', products: 'Sensitive Hand Wash + Eucalyptus Bench Spray', rrp: 34.00, price: 28.90, save: 5.10, variants: '52445517087033:1,52146498240825:1' } },
    shower: { name: 'Low Vapour Shower Cleaner', size: '500 ml — Australian made', rrp: 16.00, price: 13.60, save: 2.40, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/481.jpg?v=1723644461', variant: '49751021584697', kit: { label: 'SHOWER + MOULD SPRAY KIT', headline: 'Pair it with the mould spray', desc: 'Shower cleaner removes scum. Mould spray kills regrowth at the root.', products: 'Shower Cleaner 500ml + Mould Spray 500ml', rrp: 36.50, price: 31.03, save: 5.47, variants: '49751021584697:1,49750937502009:1' } },
    glass_stainless_glass: { name: 'Eucalyptus Hydrosol Glass Cleaner', size: '500 ml — Australian made', rrp: 14.00, price: 11.90, save: 2.10, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/476.jpg?v=1723644432', variant: '49751020273977', kit: { label: 'GLASS + STAINLESS STEEL KIT', headline: 'Shine the whole house', desc: 'Windows, mirrors, splashbacks, appliances.', products: 'Glass Cleaner + Stainless Steel Cleaner', rrp: 28.00, price: 23.80, save: 4.20, variants: '49751020273977:1,49751020372281:1' } },
    glass_stainless_stainless_steel: { name: 'All Natural Stainless Steel Cleaner', size: '500 ml — Australian made', rrp: 14.00, price: 11.90, save: 2.10, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/477.jpg?v=1723644436', variant: '49751020372281', kit: { label: 'GLASS + STAINLESS STEEL KIT', headline: 'Shine the whole house', desc: 'Windows, mirrors, splashbacks, appliances.', products: 'Stainless Steel Cleaner + Glass Cleaner', rrp: 28.00, price: 23.80, save: 4.20, variants: '49751020372281:1,49751020273977:1' } },
    glass_stainless_both: { name: 'The Shine Kit — Glass + Stainless Steel', size: 'Glass Cleaner + Stainless Steel Cleaner — both 500ml', rrp: 28.00, price: 23.80, save: 4.20, img: 'https://cdn.shopify.com/s/files/1/0734/6146/5401/files/476.jpg?v=1723644432', variant: '49751020273977', cart_variants: '49751020273977:1,49751020372281:1' }
  };

  /* ============================================================
     STATE
     ============================================================ */
  const state = {
    screen: null, history: [], branch: null, product_path: null, surface: null,
    scent: null, version: null, email: null, first_name: null, phone: null, sms_consent: false,
    insert_burnt: false, matched_product_key: null
  };

  /* ============================================================
     UTILITIES
     ============================================================ */
  function cookieGet(name) {
    const v = ('; ' + document.cookie).split('; ' + name + '=');
    return v.length === 2 ? v.pop().split(';').shift() : null;
  }
  function cookieSet(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
  }
  function cookieDelete(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  }
  function el(tag, attrs, children) {
    const e = document.createElement(tag);
    if (attrs) for (const k in attrs) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'onclick') e.addEventListener('click', attrs[k]);
      else if (k === 'html') e.innerHTML = attrs[k];
      else e.setAttribute(k, attrs[k]);
    }
    if (children) (Array.isArray(children) ? children : [children]).forEach(c => {
      if (typeof c === 'string') e.appendChild(document.createTextNode(c));
      else if (c) e.appendChild(c);
    });
    return e;
  }
  function ensureRoot() {
    let root = document.getElementById('aeoc-quiz-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'aeoc-quiz-root';
      document.body.appendChild(root);
    }
    return root;
  }
  function mount(node) {
    const root = ensureRoot();
    root.innerHTML = '';
    root.appendChild(node);
  }
  function clear() { const r = document.getElementById('aeoc-quiz-root'); if (r) r.innerHTML = ''; }
  function fmtMoney(n) { return '$' + n.toFixed(2); }
  function log(msg, data) {
    if (typeof console !== 'undefined' && console.log) console.log('[AEOCQuiz]', msg, data || '');
  }

  /* ============================================================
     ANALYTICS — per-step funnel tracking (GTM / GA4 dataLayer)
     ============================================================ */
  var quizStartVia = 'direct';
  var quizSession = '';
  function getQuizSession() {
    if (!quizSession) {
      try { quizSession = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); }
      catch (e) { quizSession = 'session'; }
    }
    return quizSession;
  }
  function track(step, props) {
    var data = Object.assign({ event: 'aeoc_quiz', quiz_step: step, session: getQuizSession() }, props || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
      if (typeof window.gtag === 'function') window.gtag('event', 'aeoc_quiz_' + step, props || {});
    } catch (e) { /* never let tracking break the quiz */ }
    if (CONFIG.quizLogUrl) {
      try {
        fetch(CONFIG.quizLogUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(Object.assign({}, data, {
            url: (typeof location !== 'undefined' ? location.pathname : ''),
            ua: (typeof navigator !== 'undefined' ? navigator.userAgent : '')
          }))
        });
      } catch (e) { /* logging must never break the quiz */ }
    }
    log('track:' + step, props || '');
  }

  /* ============================================================
     KLAVIYO EVENT PUSH
     ============================================================ */
  function fireKlaviyoEvent() {
    const payload = {
      branch: state.branch,
      scent: state.scent || null,
      surface: state.surface || null,
      version: state.version || null,
      product_path: state.product_path || null,
      matched_variant_id: PRODUCTS[state.matched_product_key]?.variant || null,
      quiz_completed_at: new Date().toISOString()
    };
    const identify = { $email: state.email, $first_name: state.first_name || undefined };
    log('Klaviyo identify:', identify);
    log('Klaviyo track "Completed Quiz":', payload);
    if (window.klaviyo && typeof window.klaviyo.push === 'function' && CONFIG.klaviyoPublicSiteId !== 'PLACEHOLDER') {
      window.klaviyo.push(['identify', identify]);
      window.klaviyo.push(['track', 'Completed Quiz', payload]);
      window.klaviyo.push(['identify', { quiz_taken: true, quiz_match_branch: state.branch, quiz_match_scent: state.scent }]);
    } else {
      log('Klaviyo not loaded or public site ID is placeholder — event will be lost. Set window.AEOC_QUIZ_CONFIG.klaviyoPublicSiteId.');
    }
  }

  /* Subscribe the email to the dedicated Quiz list WITH consent (Klaviyo Client API). */
  function subscribeToQuizList(email) {
    if (!CONFIG.quizListId || CONFIG.klaviyoPublicSiteId === 'PLACEHOLDER') {
      log('Quiz list subscribe skipped — no quizListId or placeholder site id');
      return;
    }
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Product Quiz',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            properties: {
              quiz_match_branch: state.branch || null,
              quiz_match_scent: state.scent || null,
              quiz_match_product: state.matched_product_key || null
            }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: CONFIG.quizListId } } }
      }
    };
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CONFIG.klaviyoPublicSiteId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (r) { log('Quiz list subscribe HTTP', r.status); })
        .catch(function (e) { log('Quiz list subscribe error', e); });
    } catch (e) { log('Quiz list subscribe threw', e); }
  }

  /* Fire-and-forget: notify the SMS concierge of this opt-in (answers + email + optional mobile/consent).
     Mirrors subscribeToQuizList — no-cors, try/catch, never blocks or breaks the quiz. */
  function fireConciergeOptin() {
    if (!CONFIG.conciergeOptinUrl) return;
    try {
      if (!state.matched_product_key) { try { state.matched_product_key = resolveMatchedProduct(); } catch (e) {} }
      var payload = {
        email: state.email || null,
        phone: state.phone || null,
        sms_consent: !!state.sms_consent,
        branch: state.branch || null,
        scent: state.scent || null,
        surface: state.surface || null,
        version: state.version || null,
        product_path: state.product_path || null,
        matched_product_key: state.matched_product_key || null,
        matched_variant_id: (PRODUCTS[state.matched_product_key] && PRODUCTS[state.matched_product_key].variant) || null,
        source: 'quiz',
        ts: new Date().toISOString()
      };
      fetch(CONFIG.conciergeOptinUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).catch(function () {});
      log('Concierge opt-in fired', { phone: !!state.phone, sms: !!state.sms_consent, branch: state.branch });
    } catch (e) { log('Concierge opt-in threw (ignored)', e); }
  }

  /* Value-first email capture: store + subscribe (consent) + fire flow event + track. */
  function handleQuizEmail(email, onDone) {
    state.email = email;
    state.first_name = null;
    cookieSet(CONFIG.cookies.quizTaken, '1', 30);
    subscribeToQuizList(email);
    fireKlaviyoEvent();
    fireConciergeOptin();
    track('email_captured', { branch: state.branch });
    log('Quiz email captured:', email);
    if (onDone) onDone();
  }

  /* ============================================================
     TRIGGER SYSTEM
     ============================================================ */
  const triggers = {
    showWelcome() {
      if (CONFIG.isPdp) return; // product pages get the 30s slide-up instead, not the 8s welcome
      if (cookieGet(CONFIG.cookies.quizTaken) || cookieGet(CONFIG.cookies.welcomeDismissed) || cookieGet(CONFIG.cookies.welcomeShown)) return;
      const c = CONFIG.copy.welcomePopup;
      const overlay = el('div', { class: 'aeoc-quiz-popup-overlay', id: 'aeoc-quiz-welcome-overlay' });
      // The popup IS Question 1: tapping a chip = started + Q1 answered in one motion.
      const chips = el('div', { class: 'aeoc-quiz-popup__chips' }, Q1.answers.map(ans =>
        el('button', { class: 'aeoc-quiz-popup__chip', onclick: () => { overlay.remove(); startFromChip(ans); } }, ans.text)
      ));
      const popup = el('div', { class: 'aeoc-quiz-popup' }, [
        el('div', { class: 'aeoc-quiz-popup__headline' }, CONFIG.saleMode ? c.headlineSale : (CONFIG.isReturning ? c.headlineReturning : c.headline)),
        el('div', { class: 'aeoc-quiz-popup__trust' }, [
          el('span', { class: 'aeoc-quiz-popup__stars' }, '\u2605 ' + c.trust.rating),
          el('span', { class: 'aeoc-quiz-popup__reviews' }, c.trust.reviews),
          el('span', { class: 'aeoc-quiz-popup__trust-sep' }),
          el('span', { class: 'aeoc-quiz-popup__press' }, [
            el('span', { class: 'aeoc-quiz-popup__press-label' }, c.trust.seenLabel),
            el('img', { class: 'aeoc-quiz-popup__press-logo', src: c.trust.logoUrl, alt: c.trust.logoAlt, loading: 'lazy' })
          ])
        ]),
        el('div', { class: 'aeoc-quiz-popup__prompt' }, c.prompt),
        chips,
        el('p', { class: 'aeoc-quiz-popup__micro' }, c.micro),
        el('button', { class: 'aeoc-quiz-popup__dismiss', onclick: () => { overlay.remove(); cookieSet(CONFIG.cookies.welcomeDismissed, '1', 14); } }, c.dismiss)
      ]);
      overlay.appendChild(popup);
      document.body.appendChild(overlay);
      void overlay.offsetWidth; // commit opacity:0 first so the fade still runs, then reveal directly — rAF is paused in background tabs and would otherwise leave the overlay invisible
      overlay.classList.add('is-visible');
      cookieSet(CONFIG.cookies.welcomeShown, '1', 1 / 24); // show once, then stay quiet for 1 hour even if ignored
      log('Welcome popup shown');
      track('prompt_shown', { via: 'welcome' });
    },

    showPdpSlideup() {
      if (cookieGet(CONFIG.cookies.quizTaken) || cookieGet(CONFIG.cookies.pdpSlideupShown)) return;
      if (document.getElementById('aeoc-quiz-pdp-slideup')) return;
      const slideup = el('div', { class: 'aeoc-quiz-pdp-slideup', id: 'aeoc-quiz-pdp-slideup' }, [
        el('a', { class: 'aeoc-quiz-pdp-slideup__cta', href: '#', onclick: (e) => { e.preventDefault(); slideup.remove(); quizStartVia = 'pdp'; start(); } }, CONFIG.copy.pdpSlideup),
        el('button', { class: 'aeoc-quiz-pdp-slideup__close', onclick: () => { slideup.remove(); cookieSet(CONFIG.cookies.pdpSlideupShown, '1', 1); } }, '×')
      ]);
      document.body.appendChild(slideup);
      void slideup.offsetWidth;
      slideup.classList.add('is-visible');
      log('PDP slide-up shown');
      track('prompt_shown', { via: 'pdp' });
    },

    initWelcome() {
      setTimeout(() => triggers.showWelcome(), CONFIG.delays.welcomeModalSeconds * 1000);
    },

    initPdpSlideup() {
      // Only attach scroll listener if we're on a product page
      if (!CONFIG.isPdp) return;
      if (cookieGet(CONFIG.cookies.quizTaken) || cookieGet(CONFIG.cookies.pdpSlideupShown)) return;
      let dwellOk = false, scrollOk = false, fired = false;
      const onScroll = () => {
        if (fired) return;
        const pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
        if (pct >= CONFIG.delays.pdpSlideupScrollPercent) { scrollOk = true; check(); }
      };
      const check = () => {
        if (fired) return;
        if (dwellOk || scrollOk) {  // fire on EITHER 15s dwell OR 50% scroll (whichever comes first)
          fired = true;
          window.removeEventListener('scroll', onScroll);
          triggers.showPdpSlideup();
        }
      };
      setTimeout(() => { dwellOk = true; check(); }, CONFIG.delays.pdpSlideupDwellSeconds * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    },

    initHeaderLink() {
      // Try to inject into existing nav. Fallback: append to header.
      const link = el('a', {
        class: 'aeoc-quiz-header-link',
        href: '#',
        id: 'aeoc-quiz-header-link',
        onclick: (e) => { e.preventDefault(); quizStartVia = 'header'; start(); }
      }, CONFIG.copy.headerLink);
      // Common selectors for theme nav, in priority order
      const targets = [
        '[data-aeoc-quiz-link]',                         // explicit hook if Tony adds one
        '.header__inline-menu',                          // Shopify Dawn-style
        '.header .header__menu',
        '.site-header__primary',
        'header nav',
        '.shopify-section-header nav',
        'header'
      ];
      for (const sel of targets) {
        const target = document.querySelector(sel);
        if (target) {
          target.appendChild(link);
          log('Header link injected into', sel);
          return;
        }
      }
      // Fallback: floating top-right link
      link.style.cssText = 'position:fixed;top:16px;right:16px;z-index:8000;background:rgba(255,255,255,0.95);border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,0.1);';
      document.body.appendChild(link);
      log('Header link added as fallback floating element — paste data-aeoc-quiz-link onto your nav element for cleaner placement');
    }
  };

  /* ============================================================
     QUIZ ENGINE
     ============================================================ */
  function start(ev) {
    if (ev && ev.preventDefault) ev.preventDefault();
    log('Quiz started');
    Object.assign(state, { screen: null, history: [], branch: null, product_path: null, surface: null, scent: null, version: null, email: null, first_name: null, phone: null, sms_consent: false, insert_burnt: false, matched_product_key: null });
    track('started', { via: quizStartVia });
    quizStartVia = 'direct';
    showScreen('q1');
  }

  // Welcome-popup chip tap: counts as started AND Q1 answered, lands on Q2.
  // History seeded as if Q1 was shown, so '← Back' from Q2 renders the full Q1 screen.
  function startFromChip(ans) {
    log('Quiz started via welcome chip');
    Object.assign(state, { screen: 'q1', history: [null], branch: null, product_path: null, surface: null, scent: null, version: null, email: null, first_name: null, phone: null, sms_consent: false, insert_burnt: false, matched_product_key: null });
    track('started', { via: 'welcome' });
    handleAnswer(ans);
  }

  function showScreen(key, isBack) {
    if (!isBack) state.history.push(state.screen);
    state.screen = key;
    if (key === 'q1') return renderQuestion('q1', Q1, 0, 4);
    if (key === 'email') return renderEmailGate(); // skippable email step shown before the result
    if (key === 'calculating') return renderCalculating();
    if (key === 'result') return renderResult();
    const data = BRANCHES[key];
    if (!data) { console.error('No screen for', key); return; }
    const step = key.startsWith('q4') ? 3 : key.startsWith('q3') ? 2 : 1;
    renderQuestion(key, data, step, 4);
  }

  function renderQuestion(key, data, step, total) {
    const quiz = el('div', { class: 'aeoc-quiz is-visible' });
    const header = el('div', { class: 'aeoc-quiz__header' }, [
      el('div', { class: 'aeoc-quiz__progress' }, Array.from({ length: total }, (_, i) =>
        el('div', { class: 'aeoc-quiz__progress-dot' + (i <= step ? ' is-active' : '') })
      )),
      el('div', { class: 'aeoc-quiz__counter' }, 'Question ' + (step + 1) + ' of ' + total),
      el('button', { class: 'aeoc-quiz__close', onclick: closeQuiz, 'aria-label': 'Close' }, '×')
    ]);
    const body = el('div', { class: 'aeoc-quiz__body' });
    if (data.headline) body.appendChild(el('div', { class: 'aeoc-quiz__headline' }, data.headline));
    body.appendChild(el('h2', { class: 'aeoc-quiz__question' }, data.question));
    const answers = el('div', { class: 'aeoc-quiz__answers' });
    data.answers.forEach(ans => {
      answers.appendChild(el('button', { class: 'aeoc-quiz__answer', onclick: () => handleAnswer(ans) }, ans.text));
    });
    body.appendChild(answers);
    if (state.history.length > 1) {
      body.appendChild(el('button', { class: 'aeoc-quiz__back', onclick: goBack }, '← Back'));
    }
    quiz.appendChild(header);
    quiz.appendChild(body);
    quiz.appendChild(el('div', { class: 'aeoc-quiz__trust' }, '★ 4.9 from 5,000+ reviews   ·   Australian family-made since 1895   ·   100% money-back guarantee'));
    mount(quiz);
    window.scrollTo(0, 0);
  }

  function handleAnswer(ans) {
    if (ans.set) Object.assign(state, ans.set);
    track('question_answered', { question: state.screen, next: ans.next });
    log('Answer:', ans.text, 'State:', JSON.parse(JSON.stringify(state)));
    showScreen(ans.next);
  }

  function goBack() {
    const target = state.history.pop();
    if (target) showScreen(target, true); // navigate back WITHOUT re-pushing the current screen
  }

  function closeQuiz() {
    if (confirm('Close the quiz? Your answers will not be saved.')) {
      clear();
      state.screen = null;
      log('Quiz closed by user');
    }
  }

  // Discount tier: email opt-in = 10%; adding mobile + SMS consent bumps to 15%.
  function activeDiscount() {
    return state.sms_consent
      ? { code: CONFIG.discountSms, percent: CONFIG.discountSmsPercent }
      : { code: CONFIG.discountEmail, percent: CONFIG.discountEmailPercent };
  }
  function discPrice(rrp) { return +(rrp * (1 - activeDiscount().percent / 100)).toFixed(2); }

  function renderEmailGate() {
    const c = CONFIG.copy.emailGate;
    const quiz = el('div', { class: 'aeoc-quiz is-visible' });
    const header = el('div', { class: 'aeoc-quiz__header' }, [
      el('div', { class: 'aeoc-quiz__progress' }, Array.from({ length: 4 }, () =>
        el('div', { class: 'aeoc-quiz__progress-dot is-active' })
      )),
      el('div', { class: 'aeoc-quiz__counter' }, 'Almost there'),
      el('button', { class: 'aeoc-quiz__close', onclick: closeQuiz, 'aria-label': 'Close' }, '×')
    ]);
    const body = el('div', { class: 'aeoc-quiz__body' });
    const form = el('form', { id: 'aeoc-quiz-gate-form' });
    form.appendChild((function () {
      // AEOC gate v2 (Octane) 6/7/26 — one field, 15% flat, strand headline, blurred peek, visible skip.
      var strandWords = { mould: 'mould', wall: 'mould', laundry_powder: 'laundry', laundry_liquid: 'laundry', dishwasher: 'dishwasher', bench_spray: 'kitchen', dishwash_liquid: 'kitchen', hand_wash: 'hand wash', shower: 'shower', glass_stainless: 'glass & stainless' };
      var sw = strandWords[state.branch];
      return el('h1', { class: 'aeoc-quiz__gate-headline' }, sw ? 'Your ' + sw + ' match is ready.' : c.headline);
    })());
    try {
      var peekKey = resolveMatchedProduct();
      var peekSrc = PRODUCTS[peekKey] && PRODUCTS[peekKey].img;
      if (peekSrc) {
        var peek = el('div', { style: 'text-align:center;margin:4px 0 10px;' });
        peek.appendChild(el('img', { src: peekSrc, alt: 'Your match', style: 'width:110px;height:110px;object-fit:contain;filter:blur(12px);opacity:.85;' }));
        form.appendChild(peek);
      }
    } catch (ePeek) { /* peek is optional */ }
    form.appendChild(el('p', { class: 'aeoc-quiz__gate-subline' }, CONFIG.saleMode ? 'Where should we send it? Your match — plus a code for after the sale.' : (CONFIG.isReturning ? 'Where should we send it?' : c.subline)));
    const errBox = el('div', { class: 'aeoc-quiz__error', id: 'aeoc-quiz-gate-error' });
    errBox.style.display = 'none';
    form.appendChild(errBox);
    const emailIn = el('input', { class: 'aeoc-quiz__input', type: 'email', placeholder: c.emailPlaceholder, required: 'true', id: 'aeoc-quiz-gate-email', autocomplete: 'email', inputmode: 'email', 'aria-label': 'Email address' });
    form.appendChild(emailIn);
    const submitBtn = el('button', { class: 'aeoc-quiz__submit', type: 'submit' }, CONFIG.saleMode ? 'Show my match →' : (CONFIG.isReturning ? c.cta : 'Show my match + 15% off →'));
    form.appendChild(submitBtn);
    form.appendChild(el('p', { class: 'aeoc-quiz__micro', style: 'font-size:14px;color:#1a1a1a;margin-top:10px' }, CONFIG.isReturning ? c.micro : 'No spam — your match + 15% code land in your inbox. Unsubscribe anytime.'));
    
    form.addEventListener('submit', e => {
      e.preventDefault();
      const email = emailIn.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errBox.textContent = 'We need a valid email to send your match.';
        errBox.style.display = 'block';
        return;
      }
      handleQuizEmail(email, () => showScreen('calculating'));
    });
    body.appendChild(form);
    if (state.history.length > 1) {
      body.appendChild(el('button', { class: 'aeoc-quiz__back', onclick: goBack }, '← Back'));
    }
    quiz.appendChild(header);
    quiz.appendChild(body);
    mount(quiz);
    window.scrollTo(0, 0);
  }

  function renderCalculating() {
    const quiz = el('div', { class: 'aeoc-quiz is-visible' });
    const calc = el('div', { class: 'aeoc-quiz__calc' }, [
      el('div', { class: 'aeoc-quiz__calc-spinner' }),
      el('p', { class: 'aeoc-quiz__calc-text', id: 'aeoc-quiz-calc-text' }, CONFIG.copy.calculating[0])
    ]);
    quiz.appendChild(calc);
    mount(quiz);
    const text = document.getElementById('aeoc-quiz-calc-text');
    let i = 0;
    const interval = setInterval(() => {
      i++;
      if (i < CONFIG.copy.calculating.length) {
        text.style.opacity = '0';
        setTimeout(() => { text.textContent = CONFIG.copy.calculating[i]; text.style.opacity = '1'; }, 200);
      }
    }, CONFIG.delays.calculatingSeconds * 1000 / CONFIG.copy.calculating.length);
    setTimeout(() => {
      clearInterval(interval);
      showScreen('result'); // Klaviyo event now fires only when the visitor opts in on the result page
    }, CONFIG.delays.calculatingSeconds * 1000);
  }

  /* Value-first email capture block (used below the CTA + in the result exit-catch). */
  function buildEmailCapture(opts) {
    opts = opts || {};
    const wrap = el('div', { class: 'aeoc-quiz-result__email' + (opts.cls ? ' ' + opts.cls : '') });
    if (opts.headline) wrap.appendChild(el('p', { class: 'aeoc-quiz-result__email-headline' }, opts.headline));
    const form = el('form');
    const errBox = el('div', { class: 'aeoc-quiz__error' });
    errBox.style.display = 'none';
    const input = el('input', { class: 'aeoc-quiz__input', type: 'email', placeholder: 'your@email.com', autocomplete: 'email', inputmode: 'email', 'aria-label': 'Email address' });
    const btn = el('button', { class: 'aeoc-quiz-result__email-btn', type: 'submit' }, opts.cta || 'Email my match + code');
    form.appendChild(errBox);
    form.appendChild(input);
    form.appendChild(btn);
    form.appendChild(el('p', { class: 'aeoc-quiz__micro' }, 'Your match + the occasional tip — unsubscribe any time.'));
    form.addEventListener('submit', e => {
      e.preventDefault();
      const email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errBox.textContent = 'Enter a valid email and we’ll send it over.';
        errBox.style.display = 'block';
        return;
      }
      handleQuizEmail(email, () => {
        wrap.innerHTML = '';
        wrap.appendChild(el('p', { class: 'aeoc-quiz-result__email-done' }, CONFIG.saleMode ? "✓ Sent — check your inbox. Everything's on sale right now; your code is in there for after the sale ends." : '✓ Sent — check your inbox. Your code ' + activeDiscount().code + ' is already applied at checkout.'));
      });
    });
    wrap.appendChild(form);
    return wrap;
  }

  function resolveMatchedProduct() {
    const b = state.branch;
    if (b === 'mould') return state.product_path;
    if (b === 'wall') return 'wall_cleaner';
    if (b === 'shower') return 'shower';
    if (b === 'glass_stainless') return 'glass_stainless_' + state.surface;
    if (b === 'laundry_powder') return 'laundry_powder_' + state.scent;
    if (b === 'laundry_liquid') return 'laundry_liquid_eucalyptus';
    if (b === 'dishwasher') return 'dishwasher_' + state.scent;
    if (b === 'bench_spray') return 'bench_spray_' + state.scent;
    if (b === 'dishwash_liquid') return 'dishwash_liquid_' + state.scent;
    if (b === 'hand_wash') return 'hand_wash_' + state.scent;
    return null;
  }

  function renderResult() {
    state.matched_product_key = resolveMatchedProduct();
    const p = PRODUCTS[state.matched_product_key];
    if (!p) { console.error('No product for state:', state); return; }
    cookieSet(CONFIG.cookies.quizTaken, '1', 30); // completing the quiz stops re-prompts, even without email
    track('result_shown', { branch: state.branch, product: state.matched_product_key });
    const primaryCart = p.cart_variants || (p.variant + ':1');
    // Returning customers can't use QUIZ15 (new-customers-only); during EOFY saleMode NO code is applied
    // on-site either, so it never stacks on the sale price — the codes live in the emails only.
    const noCode = CONFIG.isReturning || CONFIG.saleMode;
    const discountQS = noCode ? '' : ('?discount=' + activeDiscount().code);
    const cartLink = CONFIG.shopifyDomain + '/cart/' + primaryCart + discountQS;
    // Kits may carry their own (deeper) bundle code — e.g. MOULDKIT25 on the mould trio.
    const kitDiscountQS = (p.kit && p.kit.discountCode && !noCode) ? ('?discount=' + p.kit.discountCode) : discountQS;
    const kitCartLink = p.kit ? CONFIG.shopifyDomain + '/cart/' + p.kit.variants + kitDiscountQS : null;
    const quiz = el('div', { class: 'aeoc-quiz is-visible' });
    const header = el('div', { class: 'aeoc-quiz__header' }, [
      el('div', { class: 'aeoc-quiz__progress' }, Array.from({ length: 4 }, () =>
        el('div', { class: 'aeoc-quiz__progress-dot is-active' })
      )),
      el('div', { class: 'aeoc-quiz__counter' }, 'Your match'),
      el('button', { class: 'aeoc-quiz__close', onclick: closeQuiz, 'aria-label': 'Close' }, '×')
    ]);
    const body = el('div', { class: 'aeoc-quiz__body' });
    const result = el('div', { class: 'aeoc-quiz-result' });
    result.appendChild(el('div', { class: 'aeoc-quiz-result__brand' }, 'YOUR MATCH'));
    result.appendChild(el('div', { class: 'aeoc-quiz-result__title' }, [
      el('h1', null, state.first_name ? state.first_name + ", here's your match." : "Here's your match."),
      el('p', null, 'Based on your answers — this is the one that fits.')
    ]));
    result.appendChild(el('div', { class: 'aeoc-quiz-result__stars' }, [
      el('span', { class: 'aeoc-quiz-result__stars-row' }, '★★★★★'),
      el('span', { class: 'aeoc-quiz-result__stars-text' }, '4.9 average from 5,000+ reviews')
    ]));
    const hero = el('div', { class: 'aeoc-quiz-result__hero' });
    if (p.cart_variants) {
      const heroVariantIds = p.cart_variants.split(',').map(v => v.split(':')[0]);
      const heroImgs = heroVariantIds.map(vid => {
        const match = Object.values(PRODUCTS).find(prod => prod.variant === vid);
        return match ? match.img : null;
      }).filter(Boolean);
      const imgStrip = el('div', { class: 'aeoc-quiz-result__hero-imgs' });
      heroImgs.forEach((src, i) => {
        imgStrip.appendChild(el('img', { src: src, alt: '', class: 'aeoc-quiz-result__hero-img' }));
        if (i < heroImgs.length - 1) imgStrip.appendChild(el('span', { class: 'aeoc-quiz-result__hero-plus' }, '+'));
      });
      hero.appendChild(imgStrip);
    } else {
      hero.appendChild(el('img', { src: p.img, alt: p.name }));
    }
    hero.appendChild(el('h2', { class: 'aeoc-quiz-result__hero-name' }, p.name));
    hero.appendChild(el('p', { class: 'aeoc-quiz-result__hero-size' }, p.size));
    const heroSale = +(p.rrp * (1 - CONFIG.salePercent / 100)).toFixed(2);
    const pricing = el('p', { class: 'aeoc-quiz-result__pricing' });
    if (CONFIG.saleMode) {
      pricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-rrp' }, fmtMoney(p.rrp)));
      pricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-sale' }, fmtMoney(heroSale)));
    } else if (CONFIG.isReturning) {
      pricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-sale' }, fmtMoney(p.rrp)));
    } else {
      pricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-rrp' }, fmtMoney(p.rrp)));
      pricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-sale' }, fmtMoney(discPrice(p.rrp))));
    }
    hero.appendChild(pricing);
    if (CONFIG.saleMode) {
      hero.appendChild(el('p', { class: 'aeoc-quiz-result__save' }, CONFIG.salePercent + '% off in the EOFY sale — your price at checkout'));
    } else if (CONFIG.isReturning) {
      hero.appendChild(el('p', { class: 'aeoc-quiz-result__newcust' }, "Welcome back — here's your match."));
    } else {
      hero.appendChild(el('p', { class: 'aeoc-quiz-result__save' }, 'Save ' + fmtMoney(+(p.rrp - discPrice(p.rrp)).toFixed(2)) + ' — applied at checkout, no code to type'));
      hero.appendChild(el('p', { class: 'aeoc-quiz-result__newcust' }, 'New-customer welcome — ' + activeDiscount().percent + '% off your first order'));
    }
    hero.appendChild(el('a', { class: 'aeoc-quiz-result__cta', href: cartLink, target: '_top', onclick: () => track('add_to_cart_click', { type: 'product', product: state.matched_product_key }) }, 'Add to cart — ' + fmtMoney(CONFIG.saleMode ? heroSale : (CONFIG.isReturning ? p.rrp : discPrice(p.rrp)))));
    result.appendChild(hero);
    if (p.kit) {
      const kit = el('div', { class: 'aeoc-quiz-result__kit' });
      kit.appendChild(el('div', { class: 'aeoc-quiz-result__kit-label' }, p.kit.label));
      kit.appendChild(el('h3', { class: 'aeoc-quiz-result__kit-headline' }, p.kit.headline));
      const kitVariantIds = p.kit.variants.split(',').map(v => v.split(':')[0]);
      const kitImgs = p.kit.imgs || kitVariantIds.map(vid => {
        const match = Object.values(PRODUCTS).find(prod => prod.variant === vid);
        return match ? match.img : null;
      }).filter(Boolean);
      if (kitImgs.length >= 2) {
        const imgStrip = el('div', { class: 'aeoc-quiz-result__kit-imgs' });
        kitImgs.forEach((src, i) => {
          imgStrip.appendChild(el('img', { src: src, alt: '', class: 'aeoc-quiz-result__kit-img' }));
          if (i < kitImgs.length - 1) imgStrip.appendChild(el('span', { class: 'aeoc-quiz-result__kit-plus' }, '+'));
        });
        kit.appendChild(imgStrip);
      }
      kit.appendChild(el('p', { class: 'aeoc-quiz-result__kit-desc' }, p.kit.desc));
      kit.appendChild(el('p', { class: 'aeoc-quiz-result__kit-products' }, p.kit.products));
      const kitSale = +(p.kit.rrp * (1 - CONFIG.salePercent / 100)).toFixed(2);
      const kitPricing = el('p', { class: 'aeoc-quiz-result__pricing' });
      if (CONFIG.saleMode) {
        kitPricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-rrp' }, fmtMoney(p.kit.rrp)));
        kitPricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-sale' }, fmtMoney(kitSale)));
      } else if (CONFIG.isReturning) {
        kitPricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-sale' }, fmtMoney(p.kit.rrp)));
      } else {
        kitPricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-rrp' }, fmtMoney(p.kit.rrp)));
        kitPricing.appendChild(el('span', { class: 'aeoc-quiz-result__pricing-sale' }, fmtMoney(p.kit.discountCode ? p.kit.price : discPrice(p.kit.rrp))));
      }
      kit.appendChild(kitPricing);
      if (CONFIG.saleMode) {
        kit.appendChild(el('p', { class: 'aeoc-quiz-result__save' }, CONFIG.salePercent + '% off in the EOFY sale — both at checkout'));
      } else if (!CONFIG.isReturning) {
        kit.appendChild(el('p', { class: 'aeoc-quiz-result__save' }, p.kit.discountCode ? (p.kit.saveText || ('Save ' + fmtMoney(p.kit.save) + ' on the kit')) : ('Save ' + fmtMoney(+(p.kit.rrp - discPrice(p.kit.rrp)).toFixed(2)) + ' on the kit')));
      }
      kit.appendChild(el('a', { class: 'aeoc-quiz-result__kit-cta', href: kitCartLink, target: '_top', onclick: () => track('add_to_cart_click', { type: 'kit', product: state.matched_product_key }) }, 'Add the kit — ' + fmtMoney(CONFIG.saleMode ? kitSale : (CONFIG.isReturning ? p.kit.rrp : (p.kit.discountCode ? p.kit.price : discPrice(p.kit.rrp))))));
      result.appendChild(kit);
    }
    // Only show the result-page capture to people who SKIPPED the email step (second chance).
    // Email-givers already captured pre-result — don't ask twice or double-fire the flow.
    if (!state.email) {
      result.appendChild(buildEmailCapture({
        headline: "Want your match + code emailed so you don't lose it?",
        cta: 'Email it to me'
      }));
    }
    // SMS concierge upsell — post-reveal (moved off the gate 6/7/26). Hidden if consent already given.
    if (!CONFIG.saleMode && !state.sms_consent) {
      (function () {
        var sms = el('div', { class: 'aeoc-quiz-result__sms', style: 'margin:18px 0;padding:16px 14px;background:#eef5ee;border:1.5px solid #2e5d3a;border-radius:10px;text-align:center;' });
        sms.appendChild(el('p', { style: 'margin:0 0 8px;font-weight:700;font-size:15px;color:#1a1a1a;', html: 'Want it by text too? <span style="font-weight:500">Your code + a real person to ask anytime.</span>' }));
        var phoneIn2 = el('input', { class: 'aeoc-quiz__input', type: 'tel', placeholder: 'Mobile', autocomplete: 'tel', inputmode: 'tel', 'aria-label': 'Mobile number', style: 'margin:6px 0;' });
        sms.appendChild(phoneIn2);
        var consent2 = el('label', { style: 'display:flex;align-items:center;gap:10px;font-size:13.5px;line-height:1.4;margin:8px 0;text-align:left;color:#1a1a1a;cursor:pointer;' });
        var box2 = el('input', { type: 'checkbox' });
        box2.style.cssText = 'flex:none;width:20px;height:20px;accent-color:#2e5d3a;cursor:pointer;appearance:auto;';
        consent2.appendChild(box2);
        consent2.appendChild(el('span', { html: "Text me my code + answers when I'm stuck — unsubscribe anytime." }));
        sms.appendChild(consent2);
        var smsMsg = el('p', { style: 'display:none;margin:8px 0 0;font-weight:600;color:#2e5d3a;' }, '');
        var smsBtn = el('button', { type: 'button', class: 'aeoc-quiz__submit', style: 'margin-top:4px;' }, 'Text me my code');
        smsBtn.addEventListener('click', function () {
          var pv = (phoneIn2.value || '').trim();
          if (!pv || !box2.checked) {
            smsMsg.textContent = pv ? 'Tick the box so we can text you.' : 'Pop your mobile in first.';
            smsMsg.style.color = '#a33'; smsMsg.style.display = 'block';
            return;
          }
          state.phone = pv; state.sms_consent = true;
          try { fireConciergeOptin(); } catch (eSms) {}
          track('sms_optin_result', { branch: state.branch });
          sms.innerHTML = '';
          sms.appendChild(el('p', { style: 'margin:0;font-weight:700;color:#2e5d3a;' }, "\u2713 You're in — your code's on its way by text. Save the number, ask it anything."));
        });
        sms.appendChild(smsBtn);
        sms.appendChild(smsMsg);
        result.appendChild(sms);
      })();
    }
    result.appendChild(el('div', { class: 'aeoc-quiz-result__guarantee' }, [
      el('div', { class: 'aeoc-quiz-result__guarantee-label' }, '100% MONEY-BACK GUARANTEE'),
      el('div', { class: 'aeoc-quiz-result__guarantee-text' }, "Not completely satisfied? Send it back for a full refund or store credit — we've stood behind every product since 1895.")
    ]));
    result.appendChild(el('div', { class: 'aeoc-quiz-result__trust' }, 'Australian family business since 1895 · 100% money-back guarantee · 5,000+ reviews at 4.9 stars'));
    body.appendChild(result);
    quiz.appendChild(header);
    quiz.appendChild(body);
    mount(quiz);
    window.scrollTo(0, 0);
    setupResultExitCatch();
    log('Result rendered:', state.matched_product_key, 'Cart:', cartLink);
  }

  /* Desktop exit-intent catch on the result page — only if they haven't already given email. */
  function setupResultExitCatch() {
    let shown = false;
    const onLeave = (e) => {
      if (state.screen !== 'result') { document.removeEventListener('mouseleave', onLeave); return; }
      if (shown || state.email || e.clientY > 10) return;
      shown = true;
      document.removeEventListener('mouseleave', onLeave);
      const overlay = el('div', { class: 'aeoc-quiz-exit-overlay is-visible', id: 'aeoc-quiz-result-catch' });
      const modal = el('div', { class: 'aeoc-quiz-exit-modal' }, [
        el('h2', { class: 'aeoc-quiz-exit-modal__headline' }, "Before you go — want your match + " + activeDiscount().percent + "% code emailed so it's here when you're back?"),
        buildEmailCapture({ cta: 'Email it to me', cls: 'is-exit' }),
        el('button', { class: 'aeoc-quiz-exit-modal__dismiss', onclick: () => overlay.remove() }, 'No thanks')
      ]);
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      track('result_exit_catch_shown', { branch: state.branch });
    };
    document.addEventListener('mouseleave', onLeave);
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    log('AEOC Quiz initialised', { config: CONFIG, products: Object.keys(PRODUCTS).length });
    ensureRoot();
    triggers.initHeaderLink();
    if (!cookieGet(CONFIG.cookies.quizTaken) && !(window.Shopify && window.Shopify.designMode)) {
      triggers.initWelcome();
      triggers.initPdpSlideup();
    }
  }

  /* ============================================================
     EXPOSE GLOBALLY (for debugging + manual trigger)
     ============================================================ */
  window.AEOCQuiz = {
    start: start,
    triggers: triggers,
    state: state,
    resetCookies: function () {
      Object.values(CONFIG.cookies).forEach(cookieDelete);
      log('All cookies cleared');
    },
    config: CONFIG,
    products: PRODUCTS,
    branches: BRANCHES,
    Q1: Q1
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
